var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 176,
    height: 117,
    viewBox: "0 0 176 117",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.644 63.5H88C79.0521 63.5 71.1656 59.1383 66.1407 52.5H33C20.8694 52.5 11 62.3667 11 74.5V102C11 114.133 20.8694 124 33 124H44V140.5C44 142.616 45.2112 144.539 47.1179 145.458C47.8752 145.823 48.689 146 49.5 146C50.7246 146 51.9412 145.592 52.9348 144.797L78.9282 124H93.5C105.631 124 115.5 114.133 115.5 102V75.3879L100.644 63.5ZM63.2634 118.5C60.2308 118.5 57.75 116.04 57.75 113C57.75 109.96 60.1774 107.5 63.2047 107.5H63.2634C66.2907 107.5 68.75 109.96 68.75 113C68.75 116.04 66.2907 118.5 63.2634 118.5ZM69.7598 89.3672C67.4744 90.5918 66 93.3042 66 96.2798V99.25C66 100.77 64.77 102 63.25 102C61.73 102 60.5 100.77 60.5 99.25V96.2798C60.5 91.231 63.0486 86.7246 67.1521 84.5225C69.8323 83.0776 71.5 80.29 71.5 77.25C71.5 72.7007 67.7993 69 63.25 69C58.7007 69 55 72.7007 55 77.25C55 78.77 53.77 80 52.25 80C50.73 80 49.5 78.77 49.5 77.25C49.5 69.666 55.6687 63.5 63.25 63.5C70.8313 63.5 77 69.666 77 77.25C77 82.3203 74.2258 86.9609 69.7598 89.3672Z",
    fill: "url(#paint0_linear_1_1218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143 -8H88C75.8694 -8 66 1.8667 66 14V36C66 48.1333 75.8694 58 88 58H102.572L128.565 78.7969C129.559 79.5918 130.775 80 132 80C132.811 80 133.625 79.8228 134.382 79.4575C136.289 78.5391 137.5 76.6162 137.5 74.5V58H143C155.131 58 165 48.1333 165 36V14C165 1.8667 155.131 -8 143 -8ZM136.694 13.1943L109.194 40.6943C108.657 41.2314 107.954 41.5 107.25 41.5C106.546 41.5 105.843 41.2314 105.306 40.6943L94.3057 29.6943C93.2314 28.6201 93.2314 26.8799 94.3057 25.8057C95.3799 24.7314 97.1201 24.7314 98.1943 25.8057L107.25 34.8613L132.806 9.30566C133.88 8.23145 135.62 8.23145 136.694 9.30566C137.769 10.3799 137.769 12.1201 136.694 13.1943Z",
    fill: "url(#paint1_linear_1_1218)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1218",
    x1: 63.25,
    y1: 52.5,
    x2: 63.25,
    y2: 146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE5F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_1218",
    x1: 115.5,
    y1: -8,
    x2: 115.5,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE5F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector4);
export default __webpack_public_path__ + "static/media/vector4.86f735fb1f51dd96f33958a3407235f8.svg";
export { ForwardRef as ReactComponent };